// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__QlFtP","info":"PatientInfo_info__XcGwQ"};